/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
type UseArrayInputV2Prop = {
  value: string[];
  validation: "email" | "phone";
  onChange: (prop: string[]) => void;
  message?: string;
  separator?: "comma" | "space" | "newLine" | string;
};

export type ManageListType = {
  type:
    | "add"
    | "remove"
    | "search"
    | "toggle"
    | "bulk-edit"
    | "bulk-edit-update"
    | "cancel-bulk-edit"
    | "remove-last-one"
    | "add-item-text";
  payload: {
    data: string;
    index?: number;
  };
  // manageList: () => void;
};

export const useArrayInputV2 = ({
  value,
  onChange,
  validation,
  message,
  separator,
}: UseArrayInputV2Prop) => {
  const [list, setList] = useState<string[]>([]);
  const [search, setSearch] = useState<string>("");
  const [itemText, setItemText] = useState<string>("");
  const [error, setError] = useState<string | undefined>(undefined);
  const [bulkEdit, setBulkEdit] = useState<boolean>(false);
  const [bulkEditContent, setBulkEditContent] = useState<string>("");
  useEffect(() => {
    if (JSON.stringify(value) !== JSON.stringify(list)) {
      setList(value);
    }
  }, value);

  const SEPARATOR_LIST: any = { comma: ",", space: " ", newLine: "\n" };

  const current_separator = SEPARATOR_LIST[separator || ""] || "\n";

  const manageList = ({ type, payload }: ManageListType) => {
    let updatedList: string[] = list;

    const validate = (type: "email" | "phone", propText: string) => {
      switch (type) {
        case "email":
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(propText);
        case "phone":
          return /^[0-9]{10}$/.test(propText);
        default:
          return false;
      }
    };

    const add = () => {
      console.log("itemText", itemText);
      console.log("list", list);
      if (Array.isArray(list)) {
        setItemText("");
        return [...list, itemText];
      }
      setItemText("");
      return [itemText];
    };

    switch (type) {
      case "bulk-edit": {
        if (bulkEdit) {
          const rawItems = bulkEditContent
            .split(current_separator)
            .map((item) => item.trim())
            .filter(Boolean); // remove empty lines

          const validatedItems = rawItems.filter((item) =>
            validation ? validate(validation, item) : true
          );

          updatedList = [...new Set(validatedItems)]; // Remove duplicates
          setBulkEdit(false);
        } else {
          setBulkEdit(true);
          setSearch("");
          const multiLine = list.join(current_separator);
          setBulkEditContent(multiLine);
        }
        break;
      }
      case "cancel-bulk-edit": {
        setBulkEdit(false);
        break;
      }
      case "bulk-edit-update": {
        setBulkEditContent(payload.data);
        break;
      }

      case "add":
        if (itemText === "") {
          setError("Should not be empty.");
          break;
        }
        if (list?.includes(itemText)) {
          setError("Duplicate entry.");
          break;
        }
        if (validation) {
          if (validate(validation, itemText)) {
            updatedList = add();
            setItemText("");
          } else {
            setError(message || "Invalid input.");
          }
        } else {
          updatedList = add();
          setSearch("");
        }
        break;

      case "search":
        setSearch(payload.data);
        break;

      case "add-item-text": {
        setError(undefined);
        setItemText(payload.data);
        break;
      }

      case "remove":
        updatedList = list.filter((_, index) => index !== payload?.index);
        break;
      case "remove-last-one":
        // updatedList = list.filter((_, index) => index !== payload?.index);
        updatedList = list.slice(0, -1);
        break;

      default:
        return;
    }

    setList(updatedList);
    onChange(updatedList); // Notify parent of the change
  };

  return {
    list,
    manageList,
    search,
    error,
    bulkEdit,
    bulkEditContent,
    itemText,
    setBulkEdit,
  };
};
